require("@rails/activestorage").start()
import "./controllers"
import "./turbo_streams"
import "@hotwired/turbo-rails"

const flatpickr = require("flatpickr").default

import FroalaEditor from 'froala-editor/js/froala_editor.min.js'
global.FroalaEditor = FroalaEditor
import "froala-editor/js/plugins.pkgd.min.js"
import "chartkick/chart.js"
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

window.addEventListener('turbo:load', function() {
  document.querySelector('html').style.scrollBehavior = 'smooth'
});
window.addEventListener('turbo:before-visit', function() {
  document.querySelector('html').style.scrollBehavior = 'unset'
});
